mutation CreateOrganizationUser($input: CreateOrganizationUserInput!) {
  createOrganizationUser(input: $input) {
    id
    roles
    createdAt
  }
}

